<script lang="ts">
    import type {Intent, SearchParams} from 'src/typings';
    import KpLinkButton from 'shared/components/kp-link/KpLinkButton.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    export let availableIntents: Intent[] = [];
    export let newSearchWithParamsCallback: (newParams: SearchParams) => void;

    function newSearchWithParams(newParams: SearchParams): void {
        return newSearchWithParamsCallback(newParams);
    }
</script>

{#if availableIntents.length > 0}
    <div class="search-result-intents">
        {#each availableIntents as intent, index}
            {#if intent.type === 'go-to'}
                <KpLinkButton link={intent.link}
                              buttonStyle={index === 0 ? 'success' : 'default'}
                              data-qa="intent-button-{intent.type}"/>
            {:else if intent.type === 'modify-search-params'}
                <KpButton buttonStyle={index === 0 ? 'success' : 'default'} on:click={() => newSearchWithParams(intent.newParams)}>
                    {intent.text}
                </KpButton>
            {/if}
        {/each}
    </div>
{/if}

<style lang="less">
    .search-result-intents {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.5em
    }
</style>